import { createQueryKeys } from '../../factories';

export const AUTOMATION_NAMESPACE = ['automation', 'automations'];
export const AUTOMATION_DAILY_AI_OUTPUT_NAMESPACE = [
	'automation',
	'daily-ai-output',
];
export const automationQueryKeyFactory = createQueryKeys(AUTOMATION_NAMESPACE);
export const automationDailyAiOutputQueryKeyFactory = createQueryKeys(
	AUTOMATION_DAILY_AI_OUTPUT_NAMESPACE
);
